import Service from "@/screens/services/MainService";
import MembershipService from "@/screens/services/MembershipService";
const ConsultService = () => import("@/screens/services/ConsultService");
import VentureHireService from "@/screens/services/VentureHireService";
import VisitServiceArea from "@/screens/services/VisitServiceArea";
const ServiceGroupVisit = () => import("@/screens/services/ServiceGroupVisit");

export const serviceRouter = [

    {
        path: ":branch/service",
        name: "Service",
        component: Service,
        props: true
    },
    {
        path: "service",
        name: "Service",
        component: Service,
        props: true
    },
    {
        path: ":branch/service/membership",
        name: "MembershipService",
        component: MembershipService,
    },
    // {
    //     path: "/service/membership",
    //     name: "MembershipService",
    //     component: MembershipService,
    // },
    {
        path: ":branch/service/consult",
        name: "ConsultService",
        component: ConsultService,
    },
    // {
    //     path: "/service/consult",
    //     name: "ConsultService",
    //     component: ConsultService,
    // },
    {
        path: ":branch/service/venue-hire",
        name: "VentureHireService",
        component: VentureHireService,
    },
    // {
    //     path: "/service/venue-hire",
    //     name: "VentureHireService",
    //     component: VentureHireService,
    // },
    {
        path: ":branch/service/visit-and-service-area",
        name: "VisitServiceArea",
        component: VisitServiceArea,
    },
    // {
    //     path: "/service/visit-and-service-area",
    //     name: "VisitServiceArea",
    //     component: VisitServiceArea,
    // },
    {
        path: ":branch/service/visit-and-service-area/group-visit-detail",
        name: "ServiceGroupVisitDetail",
        component: ServiceGroupVisit,
    },
    // {
    //     path: "/service/visit-and-service-area/group-visit-detail",
    //     name: "ServiceGroupVisitDetail",
    //     component: ServiceGroupVisit,
    // },
]
